import { render } from "./Tutorial.vue?vue&type=template&id=003b97a4&ts=true"
import script from "./Tutorial.vue?vue&type=script&lang=ts"
export * from "./Tutorial.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__